import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _styled from "styled-components";
import { useEffect, useState } from "react";
import cn from "clsx";
import { css } from "styled-components";
import ScrollTopFAB from "../DashboardTemplate/ScrollTopFAB";
import useNewDashboardContext from "./context/useNewDashboardContext";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var NewRouteWrapper = function NewRouteWrapper(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    scrollTopHidden = _ref.scrollTopHidden,
    children = _ref.children;
  var _useNewDashboardConte = useNewDashboardContext(),
    sectionRef = _useNewDashboardConte.sectionRef,
    scrollTop = _useNewDashboardConte.scrollTop;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isScrolled = _useState2[0],
    setIsScrolled = _useState2[1];
  useEffect(function () {
    var onScroll = function onScroll() {
      var _sectionRef$current;
      setIsScrolled(!!((_sectionRef$current = sectionRef.current) !== null && _sectionRef$current !== void 0 && _sectionRef$current.scrollTop));
    };
    var currentNode = sectionRef.current;
    if (!scrollTopHidden && currentNode) {
      currentNode.addEventListener('scroll', onScroll);
    }
    return function () {
      if (!scrollTopHidden && currentNode) {
        currentNode.removeEventListener('scroll', onScroll);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    ref: sectionRef,
    className: cn('tw-w-full tw-h-auto', className),
    children: [children, !scrollTopHidden && /*#__PURE__*/_jsx("div", {
      className: cn('fixed bottom-0 left-0 w-full flex justify-end overflow-visible z-7', isScrolled ? 'cui-is-visible' : 'cui-is-hidden'),
      children: /*#__PURE__*/_jsx(_StyledScrollTopFAB, {
        className: "fixed w-32 h-32 cursor-pointer flex justify-center items-center",
        onScrollTop: scrollTop
      })
    })]
  });
};
export default NewRouteWrapper;
var _StyledScrollTopFAB = /*#__PURE__*/_styled(ScrollTopFAB).withConfig({
  componentId: "sc-ey282h-0"
})(["\n              bottom: 32px;\n              right: 96px;\n              left: auto;\n            "]);